// Date example
import { StringDecoder } from "@simonbackx/simple-encoding";
import { Formatter } from "@stamhoofd/utility";
import { Filter, FilterDefinition } from "./FilterDefinition";
export class ChoicesFilterChoice {
    constructor(id, name, description) {
        this.id = id;
        this.name = name;
        this.description = description;
    }
}
export var ChoicesFilterMode;
(function (ChoicesFilterMode) {
    ChoicesFilterMode["Or"] = "Or";
    ChoicesFilterMode["And"] = "And";
    /**
     * Means !(A || B) == !A && !B
     */
    ChoicesFilterMode["Nor"] = "Nor";
    /**
     * Means !(A && B) == !A || !B
     */
    ChoicesFilterMode["Nand"] = "Nand";
})(ChoicesFilterMode || (ChoicesFilterMode = {}));
export class ChoicesFilterDefinition extends FilterDefinition {
    constructor(settings) {
        super(settings);
        this.choices = [];
        this.defaultMode = ChoicesFilterMode.Or;
        if (settings.defaultMode) {
            this.defaultMode = settings.defaultMode;
        }
        this.choices = settings.choices;
    }
    decode(data) {
        var _a, _b, _c, _d;
        const filter = new ChoicesFilter();
        filter.definition = this;
        filter.choiceIds = (_b = (_a = data.optionalField("choiceIds")) === null || _a === void 0 ? void 0 : _a.array(StringDecoder)) !== null && _b !== void 0 ? _b : [];
        filter.mode = (_d = (_c = data.optionalField("mode")) === null || _c === void 0 ? void 0 : _c.enum(ChoicesFilterMode)) !== null && _d !== void 0 ? _d : this.defaultMode;
        return filter;
    }
    createFilter() {
        const filter = new ChoicesFilter();
        filter.definition = this;
        filter.mode = this.defaultMode;
        return filter;
    }
}
export class ChoicesFilter extends Filter {
    constructor() {
        super(...arguments);
        this.choiceIds = [];
        this.mode = ChoicesFilterMode.Or;
    }
    doesMatch(object) {
        if (this.choiceIds.length === 0) {
            // Empty filter does not filter
            return true;
        }
        const ids = this.definition.getValue(object);
        for (const id of this.choiceIds) {
            if (ids.includes(id)) {
                if (this.mode === ChoicesFilterMode.Or) {
                    return true;
                }
                if (this.mode === ChoicesFilterMode.Nor) {
                    return false;
                }
            }
            else {
                if (this.mode === ChoicesFilterMode.And) {
                    return false;
                }
                if (this.mode === ChoicesFilterMode.Nand) {
                    return true;
                }
            }
        }
        return this.mode === ChoicesFilterMode.And || this.mode === ChoicesFilterMode.Nor;
    }
    encode(context) {
        return {
            definitionId: this.definition.id,
            choiceIds: this.choiceIds,
            mode: this.mode
        };
    }
    toString() {
        if (this.definition.explainFilter) {
            return this.definition.explainFilter(this);
        }
        if (this.mode === ChoicesFilterMode.Or) {
            return this.definition.name + " is " + Formatter.joinLast(this.choiceIds.map(c => { var _a, _b; return (_b = (_a = this.definition.choices.find(cc => cc.id == c)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : c; }), ", ", " of ");
        }
        else if (this.mode === ChoicesFilterMode.And) {
            return this.definition.name + " is " + Formatter.joinLast(this.choiceIds.map(c => { var _a, _b; return (_b = (_a = this.definition.choices.find(cc => cc.id == c)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : c; }), ", ", " en ");
        }
        else if (this.mode === ChoicesFilterMode.Nor) {
            return this.definition.name + " is niet " + Formatter.joinLast(this.choiceIds.map(c => { var _a, _b; return (_b = (_a = this.definition.choices.find(cc => cc.id == c)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : c; }), ", niet ", " en ook niet ");
        }
        else if (this.mode === ChoicesFilterMode.Nand) {
            return this.definition.name + " is niet " + Formatter.joinLast(this.choiceIds.map(c => { var _a, _b; return (_b = (_a = this.definition.choices.find(cc => cc.id == c)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : c; }), ", niet ", " of ook niet ");
        }
    }
    get inverted() {
        const filter = this.clone();
        switch (filter.mode) {
            case ChoicesFilterMode.Or:
                filter.mode = ChoicesFilterMode.Nor;
                break;
            case ChoicesFilterMode.And:
                filter.mode = ChoicesFilterMode.Nand;
                break;
            case ChoicesFilterMode.Nor:
                filter.mode = ChoicesFilterMode.Or;
                break;
            case ChoicesFilterMode.Nand:
                filter.mode = ChoicesFilterMode.And;
                break;
        }
        return filter;
    }
}
//# sourceMappingURL=ChoicesFilter.js.map